import { ListingCardData } from "@/types/types";

export interface HomePageData {
  featured: Featured;
  most_popular: MostPopular;
  made_for_you: MadeForYou;
}

export interface HomePageDataAPIResponse {
  featured: Featured;
  most_popular: MostPopularAPIResponse;
  made_for_you: MadeForYouAPIResponse;
}

export interface Featured {
  listings: ListingCardData[];
}

export interface MostPopular {
  listings: string[];
}

export interface MadeForYou {
  listings: string[];
}

export interface MostPopularAPIResponse {
  listings: ListingCardData[];
  last_cursor: Record<string, any> | null;
  has_more_pages: boolean;
}

export interface MadeForYouAPIResponse {
  listings: ListingCardData[];
  last_precision: number;
  last_geo_hash: string;
  last_geo_hash_neighbors: string[];
  last_cursor: Record<string, any> | null;
  seen_listings: Record<string, boolean>;
  has_more_pages: boolean;
}

export const featuredInitial = <Featured>{
  listings: [],
};

export const mostPopularInitial = <MostPopular>{
  listings: [],
};

let initialSeenLiistings: Record<string, boolean> = {};
export const madeForYouInitial = <MadeForYou>{
  listings: [],
};

export const mostPopularInitialNextPageData = <MostPopularAPIResponse>{
  listings: [],
  last_cursor: {},
  has_more_pages: false,
};

export const madeForYouInitialNextPageData = <MadeForYouAPIResponse>{
  listings: [],
  last_precision: 4,
  last_geo_hash: "",
  last_geo_hash_neighbors: [],
  last_cursor: {},
  seen_listings: initialSeenLiistings,
  has_more_pages: false,
};

export interface HomePageDataV2 {
  most_popular: MostPopular;
  made_for_you: MadeForYou;
  local_cities: Location[];
  most_popular_countries: Location[];
  most_popular_cities: Location[];
}

export interface HomePageDataV2APIResponse {
  most_popular: MostPopularAPIResponse;
  made_for_you: MadeForYouAPIResponse;
  local_cities: LocalCitiesAPIResponse;
  most_popular_countries: MostPopularCountriesAPIResponse;
  most_popular_cities: MostPopularCitiesAPIResponse;
  country_name: string;
}

export interface LocalCitiesAPIResponse {
  list: Location[];
}

export interface MostPopularCountriesAPIResponse {
  list: Location[];
}

export interface MostPopularCitiesAPIResponse {
  list: Location[];
}

export interface Location {
  slug: string;
  geo_location: {
    lat: number;
    lon: number;
  };
  name: string;
  local_slug: string;
  search_url: string;
  country_code: string;
  listing_count: number;
  type: string;
  parent_slug: string | null;
  map_view: {
    north: number;
    south: number;
    east: number;
    west: number;
  };
  country_slug: string;
  photo_url: string;
}
